export default __webpack_public_path__ + "static/media/threesteps3n.e65ef4b6.jpg";